import React, { useEffect, useState } from "react";
import { Button, DatePicker, Input, Select, Switch } from "antd";
import { ErrorToast, SuccessToast } from "../../../../widgets/AppToast";
import { post } from "../../../../services/services";
import { ApiURL } from "../../../../services/apiConstants";
import useUserData from "../../../../hooks/useUserData";
import moment from "moment";
import UnitWithInput from "../../../../components/UnitWithInput";
import { pressureUnits, temperatureUnits } from "../../../../Data/data";
import dayjs from "dayjs";
import { useDate } from "../../../../context/DateContext";

export const FreshWaterGenerator = ({ eng_log_basic_id, _items }) => {
  const user = useUserData();
  const { selectedDate } = useDate();
  const [loader, set_loader] = useState(false);
  const [errors, set_errors] = useState({});
  const [staff_dashboard, set_staff_dashboard] = useState([]);
  const [running_Hour, set_Running_Hour] = useState("");
  const [total_Running_Hour, set_Total_Running_Hour] = useState("");
  const [jacket_Water_In_Temp, set_Jacket_Water_In_Temp] = useState("");
  const [jacket_Water_Out_Temp, set_Jacket_Water_Out_Temp] = useState("");
  const [vacuum, set_Vacuum] = useState("");
  const [shell_Temperature, set_Shell_Temperature] = useState("");
  const [salinity, set_Salinity] = useState("");
  const [flow_Meter, set_Flow_Meter] = useState("");
  const [quantity_Produced, set_Quantity_Produced] = useState("");
  const [feed_Water_Pressure, set_Feed_Water_Pressure] = useState("");
  const [checked, setChecked] = useState(false);
  const [update_status, set_Update_Status] = useState(false);
  const [submitStatus, setSubmitStatus] = useState(false);

  const [logDate, set_LogDate] = useState(null);
  const [jacket_Water_In_Temp_Unit, set_Jacket_Water_In_Temp_Unit] =
    useState("");
  const [jacket_Water_Out_Temp_Unit, set_Jacket_Water_Out_Temp_Unit] =
    useState("");
  const [shell_Temperature_Unit, set_Shell_Temperature_Unit] = useState("");
  const [feed_Water_Pressure_Unit, set_Feed_Water_Pressure_Unit] = useState("");
  const [otherParams, setOtherParams] = useState({});

  // Map parameter names to labels and units (including fuelOilType dynamically)
  const parameterConfig = {
    runninghours: { label: "Running Hours", unitList: [] },
    totalrunninghours: { label: "Total Running Hours", unitList: [] },
    jacketwaterintemp: {
      label: "Jacket Water In Temp",
      unitList: temperatureUnits,
    },
    jacketwaterouttemp: {
      label: "Jacket Water Out Temp",
      unitList: temperatureUnits,
    },
    vaccum: { label: "Vacuum", unitList: [] },
    shelltemperature: {
      label: "Shell Temperature",
      unitList: temperatureUnits,
    },
    salinity: { label: "Salinity", unitList: [] },
    flowmeter: { label: "Flow Meter", unitList: [] },
    qunatityproduced: { label: "Quantity Produced", unitList: [] },
    feedwaterpressure: {
      label: "Feed Water Pressure",
      unitList: pressureUnits,
    },
  };

  useEffect(() => {
    const staff_dashboards = localStorage.getItem("staff_dashboard");
    const parsedData = JSON.parse(staff_dashboards);
    set_staff_dashboard(parsedData);
    if (parsedData && _items) {
      if (_items?.id)
        VIEW_AUXILARY_MACHINARY_DETAILS_LOGBOOK_API(_items?.id, parsedData);
      const otherParamsData = Array.isArray(_items?.other_parameters)
        ? _items.other_parameters
        : [];
      const initialOtherParams = otherParamsData.reduce((acc, param) => {
        acc[param.name] = { value: "", unit: param.unit || "" };
        return acc;
      }, {});
      setOtherParams(initialOtherParams);
    }
  }, [_items?.id]);

  const onChangeDateTime = (value) => {
    if (value) {
      set_LogDate(value.format("YYYY-MM-DD HH:mm:ss"));
    } else {
      set_LogDate(null);
    }
  };

  const handleOtherParamChange = (name, field, value) => {
    setOtherParams((prev) => ({
      ...prev,
      [name]: { ...prev[name], [field]: value },
    }));
  };

  const ADD_AUXILARY_MACHINARY_DETAILS_LOGBOOK_API = (
    fresh_water_id,
    fresh_water_on
  ) => {
    set_loader(true);
    try {
      const FORM_DATA = new FormData();

      // Append common data
      FORM_DATA.append(
        "date_time_log",
        logDate || moment(new Date()).format("YYYY-MM-DD HH:mm:ss")
      );
      FORM_DATA.append("eng_log_basic_id", Number(eng_log_basic_id) || 0);
      FORM_DATA.append(
        "voyage_id",
        Number(staff_dashboard?.voyage_details?.[0]?.id) || 0
      );
      FORM_DATA.append(
        "voyage_id",
        Number(staff_dashboard?.voyage_details?.[0]?.id) || 0
      );
      FORM_DATA.append("fresh_water_on_off", fresh_water_on);

      // Append Fresh Water Parameters
      FORM_DATA.append("fresh_water_id", Number(fresh_water_id) || 0);

      FORM_DATA.append("running_hours", Number(running_Hour) || 0);
      FORM_DATA.append("total_running_hours", Number(total_Running_Hour) || 0);

      // Jacket Water Temperature In
      FORM_DATA.append(
        "jacket_water_in_temp",
        Number(jacket_Water_In_Temp) || 0
      );
      FORM_DATA.append(
        "jacket_water_in_temp_unit",
        jacket_Water_In_Temp_Unit || ""
      );

      // Jacket Water Temperature Out
      FORM_DATA.append(
        "jacket_water_out_temp",
        Number(jacket_Water_Out_Temp) || 0
      );
      FORM_DATA.append(
        "jacket_water_out_temp_unit",
        jacket_Water_Out_Temp_Unit || ""
      );

      // Vacuum
      FORM_DATA.append("vacuum", Number(vacuum) || 0);

      // Shell Temperature
      FORM_DATA.append("shell_temperature", Number(shell_Temperature) || 0);
      FORM_DATA.append("shell_temperature_unit", shell_Temperature_Unit || "");

      // Salinity
      FORM_DATA.append("salinity", Number(salinity) || 0);

      // Flowmeter
      FORM_DATA.append("flowmeter", Number(flow_Meter) || 0);

      // Quantity Produced
      FORM_DATA.append("quantity_produced", Number(quantity_Produced) || 0);

      // Feed Water Pressure
      FORM_DATA.append("feed_water_pressure", Number(feed_Water_Pressure) || 0);
      FORM_DATA.append(
        "feed_water_pressure_unit",
        feed_Water_Pressure_Unit || ""
      );

      // Append other parameters (if any)
      FORM_DATA.append("other_parameters", JSON.stringify(otherParams));

      // Submit the data via POST request
      post(ApiURL.add_auxiliary_machinery_fresh_water, FORM_DATA).then(
        (res) => {
          if (res?.status === true) {
            set_loader(false);
            SuccessToast(
              "Logbook Add Success!",
              "Logbook Auxiliary Machinery details have been successfully added!"
            );
            VIEW_AUXILARY_MACHINARY_DETAILS_LOGBOOK_API(
              res?.fresh_water_data?.fresh_water_id,
              staff_dashboard
            );
          } else {
            set_loader(false);
            const errors = res?.errors || {};
            set_errors(errors);
          }
        }
      );
    } catch (error) {
      console.error("Error in submitting fresh water data:", error);
      set_loader(false);
    }
  };

  const UPDATE_AUXILARY_MACHINARY_DETAILS_LOGBOOK_API = (
    fresh_water_id,
    save_submit,
    fresh_water_on
  ) => {
    set_loader(true); // Show loader while making the API call
    try {
      const FORM_DATA = new FormData();

      // Adding necessary fields to the FormData object
      FORM_DATA.append(
        "date_time_log",
        logDate || moment(new Date()).format("YYYY-MM-DD HH:mm:ss")
      );
      FORM_DATA.append("save_submit", Number(save_submit) || 0);
      FORM_DATA.append("fresh_water_on_off", fresh_water_on);
      FORM_DATA.append("eng_log_basic_id", Number(eng_log_basic_id) || 0);
      FORM_DATA.append(
        "voyage_id",
        Number(staff_dashboard?.voyage_details?.[0]?.id) || 0
      );
      FORM_DATA.append("fresh_water_id", Number(fresh_water_id) || 0);
      FORM_DATA.append("running_hours", Number(running_Hour) || 0);
      FORM_DATA.append("total_running_hours", Number(total_Running_Hour) || 0);

      // Jacket Water Temperature In
      FORM_DATA.append(
        "jacket_water_in_temp",
        Number(jacket_Water_In_Temp) || 0
      );
      FORM_DATA.append(
        "jacket_water_in_temp_unit",
        jacket_Water_In_Temp_Unit || ""
      );

      // Jacket Water Temperature Out
      FORM_DATA.append(
        "jacket_water_out_temp",
        Number(jacket_Water_Out_Temp) || 0
      );
      FORM_DATA.append(
        "jacket_water_out_temp_unit",
        jacket_Water_Out_Temp_Unit || ""
      );

      // Vacuum
      FORM_DATA.append("vacuum", Number(vacuum) || 0);

      // Shell Temperature
      FORM_DATA.append("shell_temperature", Number(shell_Temperature) || 0);
      FORM_DATA.append("shell_temperature_unit", shell_Temperature_Unit || "");

      // Salinity
      FORM_DATA.append("salinity", Number(salinity) || 0);

      // Flowmeter
      FORM_DATA.append("flowmeter", Number(flow_Meter) || 0);

      // Quantity Produced
      FORM_DATA.append("quantity_produced", Number(quantity_Produced) || 0);

      // Feed Water Pressure
      FORM_DATA.append("feed_water_pressure", Number(feed_Water_Pressure) || 0);
      FORM_DATA.append(
        "feed_water_pressure_unit",
        feed_Water_Pressure_Unit || ""
      );

      // Append other parameters (if any)
      FORM_DATA.append("other_parameters", JSON.stringify(otherParams));

      // Additional parameters (handling merged parameters like in your view API)
      const rawItemParams = _items?.other_parameters || [];
      rawItemParams.forEach((param) => {
        FORM_DATA.append(`other_parameter_${param.name}`, param.value || "");
        FORM_DATA.append(
          `other_parameter_${param.name}_unit`,
          param.unit || ""
        );
      });

      post(ApiURL.view_update_auxiliary_machinery_fresh_water, FORM_DATA).then(
        (res) => {
          set_loader(false); // Hide loader once the request is finished

          if (res?.status === true) {
            SuccessToast("Logbook Update Success!", res?.message);
            // Optionally, you could trigger other necessary actions after a successful submission
            if (staff_dashboard) {
              VIEW_AUXILARY_MACHINARY_DETAILS_LOGBOOK_API(
                res?.machinery_data?.machinery_id,
                staff_dashboard
              );
            }
          } else {
            ErrorToast(
              "Error message",
              "Submission failed! Please fill in all required fields and try again."
            );
            set_errors(res?.errors || {});
          }
        }
      );
    } catch (error) {
      set_loader(false); // Hide loader on error
      console.error("Error Updating logbook:", error);
    }
  };

  const VIEW_AUXILARY_MACHINARY_DETAILS_LOGBOOK_API = async (
    fresh_water_id,
    voyage_id
  ) => {
    try {
      const FORM_DATA = new FormData();
      FORM_DATA.append("fresh_water_id", fresh_water_id);
      FORM_DATA.append("eng_log_basic_id", eng_log_basic_id);
      FORM_DATA.append("voyage_id", voyage_id?.voyage_details?.[0]?.id);

      set_loader(true); // Show loader while fetching data

      post(ApiURL.view_update_auxiliary_machinery_fresh_water, FORM_DATA).then(
        (res) => {
          set_loader(false); // Hide loader once data is fetched

          const machinery_Data = res?.fresh_water_data; // Assuming fresh water machinery data in this format
          if (res?.status === true) {
            // Set state for machinery-specific parameters
            set_Update_Status(machinery_Data?.complete_status);
            set_Running_Hour(machinery_Data?.running_hours || "");
            set_Total_Running_Hour(machinery_Data?.total_running_hours || "");
            set_Jacket_Water_In_Temp(
              machinery_Data?.jacket_water_in_temp || ""
            );
            set_Jacket_Water_Out_Temp(
              machinery_Data?.jacket_water_out_temp || ""
            );
            set_Vacuum(machinery_Data?.vacuum || "");
            set_Shell_Temperature(machinery_Data?.shell_temperature || "");
            set_Salinity(machinery_Data?.salinity || "");
            set_Flow_Meter(machinery_Data?.flow_meter || "");
            set_Quantity_Produced(machinery_Data?.quantity_produced || "");
            set_Feed_Water_Pressure(machinery_Data?.feed_water_pressure || "");
            setChecked(machinery_Data?.fresh_water_on_off || false);
            setSubmitStatus(res?.submit_status || false);
            set_LogDate(
              machinery_Data?.date_time_log ||
                moment().format("YYYY-MM-DD HH:mm:ss")
            );

            // Set units for machinery parameters
            set_Jacket_Water_In_Temp_Unit(
              machinery_Data?.jacket_water_in_temp_unit || ""
            );
            set_Jacket_Water_Out_Temp_Unit(
              machinery_Data?.jacket_water_out_temp_unit || ""
            );
            set_Shell_Temperature_Unit(
              machinery_Data?.shell_temperature_unit || ""
            );
            set_Feed_Water_Pressure_Unit(
              machinery_Data?.feed_water_pressure_unit || ""
            );

            // Handle other parameters (merged with _items)
            const rawItemParams = _items?.other_parameters || [];
            const machineryParams = machinery_Data?.other_parameters || {};

            // Merge the two datasets (machinery and additional parameters)
            const mergedParams = rawItemParams.map((param) => {
              const paramName = param.name;
              const machineryEntry = machineryParams[paramName] || {};
              return {
                name: paramName,
                unit: param.unit || machineryEntry.unit || "",
                value: machineryEntry.value || "",
              };
            });

            const otherParamsData = Array.isArray(mergedParams)
              ? mergedParams
              : [];
            const initialOtherParams = otherParamsData.reduce((acc, param) => {
              acc[param.name] = {
                value: param.value || "",
                unit: param.unit || "",
              };
              return acc;
            }, {});

            setOtherParams(initialOtherParams);
          } else {
            set_errors(res?.errors || {});
          }
        }
      );
    } catch (error) {
      set_loader(false); // Hide loader on error
      console.error("Error updating logbook:", error);
    }
  };

  const otherParameterUnits = [
    ...new Set(Object.values(otherParams || {}).map((param) => param.unit)),
  ];

  return (
    <>
      <div className="row custom-box">
        <div className="col-3">
          <b style={{ color: "#161515", fontSize: "14px" }}>
            Machinary Make:- {_items?.machinary_make}
          </b>
        </div>
        <div className="col-3">
          <b style={{ color: "#161515", fontSize: "14px" }}>
            Machinary Model:- {_items?.machinary_model}
          </b>
        </div>
        <div className="col-3">
          <b style={{ color: "#161515", fontSize: "14px" }}>
            Machinary Name :- {_items?.machinary_name}
          </b>
        </div>
        <div className="col-3">
          <b style={{ color: "#161515", fontSize: "14px" }}>
            Machinary Id:- {_items?.id}
          </b>
        </div>

        <div className="col-2">
          <Switch
            disabled={submitStatus}
            checked={checked}
            onChange={(value) => {
              setChecked(value);
              if (value || !value) {
                update_status
                  ? UPDATE_AUXILARY_MACHINARY_DETAILS_LOGBOOK_API(
                      _items?.id,
                      "0",
                      value
                    )
                  : ADD_AUXILARY_MACHINARY_DETAILS_LOGBOOK_API(
                      _items?.id,
                      value
                    );
              }
            }}
            checkedChildren="On"
            unCheckedChildren="Off"
            style={{ backgroundColor: checked ? "green" : "red" }}
          />
        </div>
      </div>

      {checked && (
        <>
          {(() => {
            const rows = [];

            // Prepare the list of inputs: Start with Date & Time
            const inputs = [
              {
                type: "dateTime",
                name: "dateTime",
                // value: logDate,
                value: update_status && logDate ? logDate : selectedDate,
              },
            ];

            const selectedParams = _items.selected_parameters || [];

            selectedParams.forEach((param) => {
              const config = parameterConfig[param];
              if (config) {
                const stateMap = {
                  runninghours: [running_Hour, set_Running_Hour],
                  totalrunninghours: [
                    total_Running_Hour,
                    set_Total_Running_Hour,
                  ],
                  jacketwaterintemp: [
                    jacket_Water_In_Temp,
                    set_Jacket_Water_In_Temp,
                  ],
                  jacketwaterouttemp: [
                    jacket_Water_Out_Temp,
                    set_Jacket_Water_Out_Temp,
                  ],
                  vaccum: [vacuum, set_Vacuum],
                  shelltemperature: [shell_Temperature, set_Shell_Temperature],
                  salinity: [salinity, set_Salinity],
                  flowmeter: [flow_Meter, set_Flow_Meter],
                  qunatityproduced: [quantity_Produced, set_Quantity_Produced],
                  feedwaterpressure: [
                    feed_Water_Pressure,
                    set_Feed_Water_Pressure,
                  ],
                };

                const [value] = stateMap[param] || [];
                const unitStateMap = {
                  jacketwaterintemp: [
                    jacket_Water_In_Temp_Unit,
                    set_Jacket_Water_In_Temp_Unit,
                  ],
                  jacketwaterouttemp: [
                    jacket_Water_Out_Temp_Unit,
                    set_Jacket_Water_Out_Temp_Unit,
                  ],
                  shelltemperature: [
                    shell_Temperature_Unit,
                    set_Shell_Temperature_Unit,
                  ],
                  feedwaterpressure: [
                    feed_Water_Pressure_Unit,
                    set_Feed_Water_Pressure_Unit,
                  ],
                };

                const [unit] = unitStateMap[param] || [];
                inputs.push({
                  type: "selectedParam",
                  name: param,
                  config,
                  value,
                  unit,
                });
              }
            });

            // Render inputs in groups of 3

            for (let i = 0; i < inputs.length; i += 3) {
              const group = inputs.slice(i, i + 3);
              rows.push(
                <div className="row" key={`combined-row-${i}`}>
                  {group.map((input, idx) => (
                    <div
                      className="col-4"
                      key={`${input.type}-${input.name}-${idx}`}
                    >
                      {input.type === "dateTime" ? (
                        <div className="input-box">
                          <label>Date & Time</label>
                          <DatePicker
                            showTime
                            format="YYYY-MM-DD HH:mm:ss"
                            placeholder="Select Date & Time"
                            value={
                              input.value
                                ? dayjs(input.value, "YYYY-MM-DD HH:mm:ss")
                                : null
                            }
                            onChange={onChangeDateTime}
                            style={{ width: "100%" }}
                            // disabled={submitStatus}
                            disabled
                          />
                          {errors.date_time_log && (
                            <p className="error-text">{errors.date_time_log}</p>
                          )}
                        </div>
                      ) : (
                        (() => {
                          const config = input.config;
                          const stateMap = {
                            runninghours: [running_Hour, set_Running_Hour],

                            totalrunninghours: [
                              total_Running_Hour,
                              set_Total_Running_Hour,
                            ],
                            jacketwaterintemp: [
                              jacket_Water_In_Temp,
                              set_Jacket_Water_In_Temp,
                            ],
                            jacketwaterouttemp: [
                              jacket_Water_Out_Temp,
                              set_Jacket_Water_Out_Temp,
                            ],
                            vaccum: [vacuum, set_Vacuum],
                            shelltemperature: [
                              shell_Temperature,
                              set_Shell_Temperature,
                            ],
                            salinity: [salinity, set_Salinity],
                            flowmeter: [flow_Meter, set_Flow_Meter],
                            qunatityproduced: [
                              quantity_Produced,
                              set_Quantity_Produced,
                            ],
                            feedwaterpressure: [
                              feed_Water_Pressure,
                              set_Feed_Water_Pressure,
                            ],
                          };
                          const [, setValue] = stateMap[input.name] || [];
                          const unitStateMap = {
                            jacketwaterintemp: [
                              jacket_Water_In_Temp_Unit,
                              set_Jacket_Water_In_Temp_Unit,
                            ],
                            jacketwaterouttemp: [
                              jacket_Water_Out_Temp_Unit,
                              set_Jacket_Water_Out_Temp_Unit,
                            ],
                            shelltemperature: [
                              shell_Temperature_Unit,
                              set_Shell_Temperature_Unit,
                            ],
                            feedwaterpressure: [
                              feed_Water_Pressure_Unit,
                              set_Feed_Water_Pressure_Unit,
                            ],
                          };
                          const [, setUnit] = unitStateMap[input.name] || [];
                          const errorKey = `pr_${input.name.replace(
                            /([A-Z])/g,
                            (match) => `_${match.toLowerCase()}`
                          )}`;

                          return config.unitList && config.unitList.length ? (
                            <UnitWithInput
                              label={config.label}
                              value={input.value}
                              onChange={(e) => setValue(e.target.value)}
                              unit={input.unit}
                              onUnitChange={(e) => setUnit(e.target.value)}
                              disabled={submitStatus}
                              error={errors[errorKey]}
                              unitList={config.unitList}
                            />
                          ) : (
                            <div className="input-box">
                              <label>{config.label}</label>
                              <Input
                                disabled={submitStatus}
                                value={input.value}
                                placeholder={config.label}
                                onChange={(e) => setValue(e.target.value)}
                              />
                              {errors?.[errorKey] && (
                                <span style={{ color: "red" }}>
                                  {errors[errorKey]}
                                </span>
                              )}
                            </div>
                          );
                        })()
                      )}
                    </div>
                  ))}
                  {group.length < 3 &&
                    Array.from({ length: 3 - group.length }).map((_, idx) => (
                      <div
                        className="col-4"
                        key={`empty-combined-${i}-${idx}`}
                      ></div>
                    ))}
                </div>
              );
            }

            return rows;
          })()}

          {(() => {
            const rows = [];
            const otherParamsArray = Object.entries(otherParams || {});
            for (let i = 0; i < otherParamsArray.length; i += 3) {
              const group = otherParamsArray.slice(i, i + 3);
              rows.push(
                <div className="row" key={`other-row-${i}`}>
                  {group.map(([name, { value, unit }]) => (
                    <div className="col-4" key={name}>
                      <UnitWithInput
                        label={name}
                        value={value}
                        onChange={(e) =>
                          handleOtherParamChange(name, "value", e.target.value)
                        }
                        unit={unit}
                        onUnitChange={(e) =>
                          handleOtherParamChange(name, "unit", e.target.value)
                        }
                        disabled={submitStatus}
                        unitList={otherParameterUnits}
                      />
                    </div>
                  ))}
                  {group.length < 3 &&
                    Array.from({ length: 3 - group.length }).map((_, idx) => (
                      <div
                        className="col-4"
                        key={`empty-other-${i}-${idx}`}
                      ></div>
                    ))}
                </div>
              );
            }
            return rows;
          })()}

          <div
            className="row"
            style={{
              display: "flex",
              alignItems: "center",
              gap: "15px",
              marginLeft: "5px",
            }}
          >
            {["Chief Engineer"].includes(user?.data?.designation) &&
              eng_log_basic_id && (
                <Button
                  disabled={submitStatus}
                  loading={loader}
                  className="save_btn"
                  style={{ color: "white" }}
                  onClick={() =>
                    update_status
                      ? UPDATE_AUXILARY_MACHINARY_DETAILS_LOGBOOK_API(
                          _items?.id,

                          "1",
                          checked
                        )
                      : ADD_AUXILARY_MACHINARY_DETAILS_LOGBOOK_API(
                          _items?.id,
                          checked
                        )
                  }
                >
                  Submit
                </Button>
              )}
            <Button
              disabled={submitStatus}
              loading={loader}
              className="save_btn"
              style={{ color: "white" }}
              onClick={() =>
                update_status
                  ? UPDATE_AUXILARY_MACHINARY_DETAILS_LOGBOOK_API(
                      _items?.id,

                      "0",
                      checked
                    )
                  : ADD_AUXILARY_MACHINARY_DETAILS_LOGBOOK_API(
                      _items?.id,
                      checked
                    )
              }
            >
              Save
            </Button>
          </div>
        </>
      )}
    </>
  );
};
